@let formGroupValue = formGroup();
@if (formGroupValue) {
<ng-container [formGroup]="formGroupValue">
  <mat-form-field appearance="outline" class="form-field">
    <mat-label>{{label()}}</mat-label>
    <input
      #htmlInput
        matInput
        [required]="required()"
        [formControlName]="name()"
        [errorStateMatcher]="errorStateMatcher()"
        [matAutocomplete]="auto">
    <mat-icon matSuffix>arrow_drop_down</mat-icon>
    <mat-autocomplete #auto="matAutocomplete">
      @for(option of filteredOptions(); track option) {
        <mat-option [value]="option">{{option}}</mat-option>
      }
    </mat-autocomplete>
    <mat-error>
      {{error()}}
    </mat-error>
  </mat-form-field>
</ng-container>
}
